const JsPagination = {
  init () {

    /*              __
                   / _)         
            .-^^^-/ /          
        __/       /              
        <__.|_|-|_|  

        The Emagine Dinosaur says; "Sometimes we need to fake pagination, when we can't actually paginate, like a grid in EE.".          
    */

    if ( $('.c-pagination-container .c-pagination-item').length ) {

      var isotopeInUse = false;

      if( $('.c-pagination-container').hasClass('isotope-grid') ) {
        isotopeInUse = true;
      }

      // If pagination container uses isotope, call layout
      if ( isotopeInUse == true ) {
        $('.isotope-grid').isotope('layout');
      }

      // Find length of full list
      var listSize = $('.c-pagination-container .c-pagination-item').length

      // Declare initial amount to load
      var initialList = 6;
      
      // Once there are no more items to show, hide load more button, we check this initially because there may be too few items to load
      if (listSize <= initialList) {

        $('.paginate-next').hide();

        // There's less than our initial amount, just show them all
        $('.c-pagination-container .c-pagination-item').removeClass('c-pagination-item-not-loaded');

        // if pagination container uses isotope for masonry layout, tell Isotope to reveal hidden elements, and then call layout
        if ( isotopeInUse == true ) {
          $('.isotope-grid').isotope( 'revealItemElements', initialElems );
          $('.isotope-grid').isotope('layout');
        }

      } else {

        // Show initial amount
        var initialElems = $('.c-pagination-container .c-pagination-item:lt(' + initialList + ')').toArray();
        $('.c-pagination-container .c-pagination-item:lt(' + initialList + ')').removeClass('c-pagination-item-not-loaded');

        // if pagination container uses isotope for masonry layout, tell Isotope to reveal hidden elements, and then call layout
        if ( isotopeInUse == true ) {
          $('.isotope-grid').isotope( 'revealItemElements', initialElems );
          $('.isotope-grid').isotope('layout');
        }

        // Insert pagination items into pagination container based on load more click
        $('.paginate-next').on( 'click', function() {

          // If pagination container uses isotope for masonry layout, call layout now
          if ( isotopeInUse == true ) {
            $('.c-gallery').isotope('layout');
          }

          initialList = initialList + 6 <= listSize ? initialList + 6 : listSize;
          var elems = $('.c-pagination-container .c-pagination-item:lt(' + initialList + ')').toArray();

          // insert new elements
          $('.c-pagination-container .c-pagination-item:lt(' + initialList + ')').removeClass('c-pagination-item-not-loaded');

          // if pagination container uses isotope for masonry layout, tell Isotope to reveal hidden elements, and then call layout
          if ( isotopeInUse == true ) {
            $('.isotope-grid').isotope( 'revealItemElements', elems );
            $('.isotope-grid').isotope('layout');
          }

          // Once there are no more items to show, hide load more button
          if (listSize <= initialList) {
            $('.paginate-next').hide();
          }

        });
      }
    }

  }
};

export default JsPagination;


// WEBPACK FOOTER //
// ./src/components/03-ui/pagination/pagination.js